import styled, { css } from "styled-components"

import { eq, minWidth } from "utils"

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 2.7rem 4rem;

  ${minWidth.tablet`
    padding: 0 4rem 4rem;
  `}

  ${minWidth.hamburgerLarge`
    ${eq("priority", 1)`
      max-width: 100%;
      padding: 0 4rem 6rem;
    `}

    ${eq("priority", 2)`
      max-width: 72.5rem;
      margin: 0 auto;
      padding: 0 4rem 6rem;
    `}

    ${eq("priority", 3)`
      width: 33.33%;
      max-width: 32rem;
      margin-left: 8.33%;
      padding: 0 4rem 1rem 0;
      display: inline-block;
      float: left;
    `}
  `}
`

export const Youtube = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-bottom: 56.25%;

  > iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    max-width: 100% !important;
    height: 100%;
    margin: 0 auto !important;
    border: 0 !important;
  }
`

export const Content = styled.div`
  max-width: 100%;

  > iframe, blockquote {
    max-width: 100%;
  }
`
